// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    border-radius: 0px !important;
}
.modal {
    position: absolute;
    top: 50px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000000;
    display: block;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
}
.modal-dialog {
  width: 520px;
  margin: 30px auto;
  position: absolute;
  /*top: 50%;
    left: 77%;*/
  bottom: 70px;
  right: 80px;
}
.modal-body {
  padding: 15px 25px 25px 25px !important;
}
.modal-footer {
    /* padding-top: -12px; */
    padding: 0px;
    border-top-color: transparent;
    box-shadow: none;
    background-color: white !important;
}
.modal-header {
    padding: 6px;
    border-bottom: 1px solid transparent;
    background-color: #165788 !important;
}
.modal-title {
    margin: 5px;
    line-height: 1.428571;
    color: aliceblue;
    font-size: 14px;
}

.tblPermitTemplate {
    width: 98%;
}

.clsLogo {
    height: 51px;
    width: 180px;
    /* border: 1px solid #1F4E78; */
    padding-right: 5px;
    margin-top: 7px;
}

.clsLogoHidden {
    height: 45px;
    width: 157px;
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: -5px;
}
.mapImage{
    height: 800px !important;
}

.clsHeader {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
}

.clsHeaderWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; */
}

.clsHeaderHiddenChild {
    background-color: White;
    width: 30px;
    height: 100%;
    position: absolute;
    left: 10px;
}

/* .clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 40px;
    padding: 10px;
    font-weight: bold;
   
}
.clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; 
} */

.clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
}

.clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
    /* margin-left: -6px; */
}

.tblPermitTemplate td {
    /* color: #1F4E78; */
    background-color: white;
}

.tblPermitTemplate tr {
    border: 1px solid #1F4E78;
}

.tblPermitTemplate tr th {
    background-color: #1F4E78;
    color: white;
}
.tblForApprover {
    width: 98%;
}
.tblForApprover td {
    /* color: #1F4E78; */
    background-color: white;
}
.tblForApprover tr {
    border: 1px solid white;
}

.tblForApprover tr th{
    color: white;
}
.tblForApprover tr td, .tblForApprover tr th {
    padding: 6px;
}

.tblPermitTemplate tr td, .tblPermitTemplate tr th {
    padding: 6px;
}

.clsValue {
    color: black;
    /* font-weight: bold; */
    margin-left: 5px;
}

.clsTextArea {
    color: black;
    border: 1px solid #1F4E78;
    resize: none;
}

.clsTable {
    margin: 5px 5px 0px 0px;
    width: 100%;
}

.clsTable td {
    border: 1px solid #1F4E78;
}

.clsTable th {
    border: 1px solid black;
}

.clsTablesContainer {
    overflow: auto;
    margin-bottom: 5px;
}

.clsBgWhite {
    background-color: white;
    /* margin-bottom: 10px; */
}

.clsHeaderParent {
    width: 98.7%;
    padding-left: 30px;
    background-color: White;
}

#pnlPreviewTemp {
    background-color: white;
    position: relative;
    top: -100px;
    padding-left: 30px;
    padding-top: 30px;
    padding-right: 30px;
}

/* .clsMarginBottom {
    margin-top: 15px !important;
    line-height: 30px;
    border-collapse: separate;
    border-spacing: 0 2em; 
}*/

.clsCheckboxContainer {
    padding: 5px;
    color: black;
}

.clsCheckBox {
    height: 80px;
    overflow: auto;
}

.clsCheckboxDownContainer {
    padding: 5px;
    color: black;
}

.btn-primary {
    margin-right: 5px !important;
}
.btn-permit {
    margin-left: 15px !important;
    border-radius: 50% !important;
    font-size:22px;
    background-color: #165688!important;
    cursor: pointer;
}
.btn-permit-disabled {
    margin-left: 15px !important;
    border-radius: 50% !important;
    font-size:22px;
    background-color: #165688!important;
    cursor: not-allowed !important;
}
/* .button-shadow {
    box-shadow: 0 3.5px 7.8px 0 rgba(0,0,0,.532), 0 0.6px 2px 0 rgba(0,0,0,.508) !important;
} */
.div-buttons {
    z-index: 5;
    position: fixed;
    bottom: -7%;
    margin-bottom: 68px;
    display: flex;
    flex-direction: row-reverse;
    /* width: 94.5%; */
    right: 45px;
}
.comment {
    z-index: 5;
    position: fixed;
    bottom: -7%;
    margin-bottom: 68px;
    justify-content: flex-start;
    display: flex;
    margin-left: 36px !important;
}
:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    box-shadow: 3px 3px 12px #165788;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .ui-inputtext {
    /* width: 250px !important; */
    margin: 0;
    outline: medium none;
    padding: .25em;
    font-weight: normal;
}

:host ::ng-deep input[type=text] {
    border-radius: 0px !important;
}

:host ::ng-deep input[disabled] {
    color: #848484!important;
    background-color: white!important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header {
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;
}

.approveMessage {
    font-style: italic;
    font-weight: normal;
    font-size: 11px;
}

/* .permitTypeImages {
    height: 62px;
    width: 100%;
} */

.permitTypeImages {
    /* max-height: 88px;
    height: 100%;
     width: 100%;
     min-width: 88px; */
    /* width: 100%;
     height: 100%; */
    width: 70px;
    height: 71px;
}

#messagebox {
    border: solid 1px #cecece;
    color: #4B515D;
}

#messagebox.success {
    /* border: solid 1px #00C851;
    border-left: solid 4px #00C851; */
    padding: 10px;
}

.success-color {
    color: transparent;
}

.status {
    padding: 2px;
    font-size: 13px;
}

.message-header {
    font-size: 14px;
    font-weight: bold;
}

.message-border {
    margin: 5px;
    height: auto;
    width: auto;
    border: 1px solid rgba(22, 87, 136, 0.8);
    border-left: 5px solid rgba(22, 87, 136, 0.8);
    padding: 5px;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}

.status-overlay {
    position: fixed;
    right: 30px;
    /* top: 97px; */
    /* top: 8%; */
    top: 55px;
    width: 76px;
    height: 23px;
    /* bottom: 7px; */
    margin-left: 12px;
    padding-top: 2px;
    cursor: pointer;
    background-color: #165788;
    color: #FFF !important;
    background-position: -496px -229px;
    padding-left: 7px;
    letter-spacing: 0.5px;
    border: 1px solid #165788;
    border-radius: 5px;
    box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.7);
}

.geo-tag {
    position: fixed;
    right: 52px;
    /* top: 90px; */
    top: 8%;
    width: 76px;
    height: 23px;
    /* bottom: 7px; */
    margin-left: 12px;
    padding-top: 2px;
    cursor: pointer;
}

#commentBoxContainer {
    background-color: white;
    width: 98.5%;
    height: 400px;
    position: sticky;
    top: 87px;
    z-index: 1000;
    right: 643px;
    margin-left: 5px;
    border: 1px solid #165788;
    border-radius: 5px 5px 0px 0px !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25)
}

.msg_send_btn:focus {
    border: 0px solid black !important;
}

.userImage {
    height: 80px !important;
    width: 72px !important;
    padding: 2px !important;
    border: 2px solid #165788 !important;
}

.status-user-tab {
    border-bottom: 3px solid #165788;
}

.msg_send_btn {
    border: 0px solid black !important;
}

.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

hr {
    clear: both;
    margin-top: 10px;
    margin-bottom: 10px;
}

.vrtAlignLbl {
    padding: 0px 0px 0px 0px;
    font: 13px !important;
}

.hiddenDiv {
    /* height: 0; */
    overflow: hidden;
    height: 0;
    /* display: none; */
}

#pnlPreview {
    background-color: white;
    position: relative;
    /* top: -40px; */
    padding-left: 30px;
    padding-top: 0px;
    /* padding-right: 30px; */
}

.left {
    display: table-cell;
    /* width:6%; */
}

.middle {
    display: table-cell;
    width: 100%;
}

.right {
    display: table-cell;
    width: 10%;
}

span {
    color: #000000 !important;
}

.clsTablesContainer td {
    border-color: Gray !important;
}

.disabled {
    cursor: not-allowed !important;
    pointer-events: none;
}

:host ::ng-deep .ui-datepicker table td {
    padding: 0 !important;
}
.clsMandatory{
    border-color: red !important;
}
/* .pageNum {
    font-family: "DejaVu Sans", "Arial", sans-serif;
    position: absolute;
    top: 10px;
    left: 10px;
  } */
  .btn-permit:hover {
    border-color: none;
    transform: scale(1.3);
   }

   .export-button-active {
       cursor: pointer;
   }

   .export-button-disabled {
    cursor: not-allowed;
    filter: grayscale(1);
    opacity: 0.6;
}
.export-button:hover {
    transform: scale(1.15);
}
.export-button-2:hover {
    /* box-shadow: 0 3.5px 7.8px 0 rgba(0,0,0,.532), 0 0.6px 2px 0 rgba(0,0,0,.508) !important; */
    transform: scale(1.05);
}


  kendo-pdf-export {
    font-family: "DejaVu Sans", "Arial", "sans-serif";
    /* font-size: 16px; */
   } 

   @font-face {
    font-family: "DejaVu Sans";
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf") format("truetype");
  }

  @font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf") format("truetype");
  }

  @font-face {
    font-family: "DejaVu Sans";
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
  }

  @font-face {
    font-family: "DejaVu Sans";
    font-weight: bold;
    font-style: italic;
    src: url("https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf") format("truetype");
  }
 
`, "",{"version":3,"sources":["webpack://./src/app/work-permit/work-permit.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,UAAU;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;eACa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,uCAAuC;AACzC;AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;;EAKE;;AAEF;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,cAAc;IACd,mCAAmC;IACnC,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,cAAc;IACd,mCAAmC;IACnC,8BAA8B;AAClC;AACA;;GAEG;AACH;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAG9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;IACI;;;uBAGmB;IACnB;oBACgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;qCACiC;IACjC,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,6CAA6C;IAC7C,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;IACzC;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,4BAA4B;AAChC;AACA;;;;;KAKK;EACH;IACE,kBAAkB;IAClB,qBAAqB;GACtB;;GAEA;OACI,eAAe;GACnB;;GAEA;IACC,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,6FAA6F;IAC7F,sBAAsB;AAC1B;;;EAGE;IACE,iDAAiD;IACjD,qBAAqB;GACtB;;GAEA;IACC,0BAA0B;IAC1B,0GAA0G;EAC5G;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,+GAA+G;EACjH;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,kHAAkH;EACpH;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,kHAAkH;EACpH","sourcesContent":["* {\r\n    border-radius: 0px !important;\r\n}\r\n.modal {\r\n    position: absolute;\r\n    top: 50px;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 100000000;\r\n    display: block;\r\n    overflow: hidden;\r\n    -webkit-overflow-scrolling: touch;\r\n    outline: 0;\r\n}\r\n.modal-dialog {\r\n  width: 520px;\r\n  margin: 30px auto;\r\n  position: absolute;\r\n  /*top: 50%;\r\n    left: 77%;*/\r\n  bottom: 70px;\r\n  right: 80px;\r\n}\r\n.modal-body {\r\n  padding: 15px 25px 25px 25px !important;\r\n}\r\n.modal-footer {\r\n    /* padding-top: -12px; */\r\n    padding: 0px;\r\n    border-top-color: transparent;\r\n    box-shadow: none;\r\n    background-color: white !important;\r\n}\r\n.modal-header {\r\n    padding: 6px;\r\n    border-bottom: 1px solid transparent;\r\n    background-color: #165788 !important;\r\n}\r\n.modal-title {\r\n    margin: 5px;\r\n    line-height: 1.428571;\r\n    color: aliceblue;\r\n    font-size: 14px;\r\n}\r\n\r\n.tblPermitTemplate {\r\n    width: 98%;\r\n}\r\n\r\n.clsLogo {\r\n    height: 51px;\r\n    width: 180px;\r\n    /* border: 1px solid #1F4E78; */\r\n    padding-right: 5px;\r\n    margin-top: 7px;\r\n}\r\n\r\n.clsLogoHidden {\r\n    height: 45px;\r\n    width: 157px;\r\n    padding-right: 5px;\r\n    padding-top: 10px;\r\n    padding-bottom: -5px;\r\n}\r\n.mapImage{\r\n    height: 800px !important;\r\n}\r\n\r\n.clsHeader {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n}\r\n\r\n.clsHeaderWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; */\r\n}\r\n\r\n.clsHeaderHiddenChild {\r\n    background-color: White;\r\n    width: 30px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 10px;\r\n}\r\n\r\n/* .clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 40px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n   \r\n}\r\n.clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; \r\n} */\r\n\r\n.clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n    /* margin-left: -6px; */\r\n}\r\n\r\n.tblPermitTemplate td {\r\n    /* color: #1F4E78; */\r\n    background-color: white;\r\n}\r\n\r\n.tblPermitTemplate tr {\r\n    border: 1px solid #1F4E78;\r\n}\r\n\r\n.tblPermitTemplate tr th {\r\n    background-color: #1F4E78;\r\n    color: white;\r\n}\r\n.tblForApprover {\r\n    width: 98%;\r\n}\r\n.tblForApprover td {\r\n    /* color: #1F4E78; */\r\n    background-color: white;\r\n}\r\n.tblForApprover tr {\r\n    border: 1px solid white;\r\n}\r\n\r\n.tblForApprover tr th{\r\n    color: white;\r\n}\r\n.tblForApprover tr td, .tblForApprover tr th {\r\n    padding: 6px;\r\n}\r\n\r\n.tblPermitTemplate tr td, .tblPermitTemplate tr th {\r\n    padding: 6px;\r\n}\r\n\r\n.clsValue {\r\n    color: black;\r\n    /* font-weight: bold; */\r\n    margin-left: 5px;\r\n}\r\n\r\n.clsTextArea {\r\n    color: black;\r\n    border: 1px solid #1F4E78;\r\n    resize: none;\r\n}\r\n\r\n.clsTable {\r\n    margin: 5px 5px 0px 0px;\r\n    width: 100%;\r\n}\r\n\r\n.clsTable td {\r\n    border: 1px solid #1F4E78;\r\n}\r\n\r\n.clsTable th {\r\n    border: 1px solid black;\r\n}\r\n\r\n.clsTablesContainer {\r\n    overflow: auto;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.clsBgWhite {\r\n    background-color: white;\r\n    /* margin-bottom: 10px; */\r\n}\r\n\r\n.clsHeaderParent {\r\n    width: 98.7%;\r\n    padding-left: 30px;\r\n    background-color: White;\r\n}\r\n\r\n#pnlPreviewTemp {\r\n    background-color: white;\r\n    position: relative;\r\n    top: -100px;\r\n    padding-left: 30px;\r\n    padding-top: 30px;\r\n    padding-right: 30px;\r\n}\r\n\r\n/* .clsMarginBottom {\r\n    margin-top: 15px !important;\r\n    line-height: 30px;\r\n    border-collapse: separate;\r\n    border-spacing: 0 2em; \r\n}*/\r\n\r\n.clsCheckboxContainer {\r\n    padding: 5px;\r\n    color: black;\r\n}\r\n\r\n.clsCheckBox {\r\n    height: 80px;\r\n    overflow: auto;\r\n}\r\n\r\n.clsCheckboxDownContainer {\r\n    padding: 5px;\r\n    color: black;\r\n}\r\n\r\n.btn-primary {\r\n    margin-right: 5px !important;\r\n}\r\n.btn-permit {\r\n    margin-left: 15px !important;\r\n    border-radius: 50% !important;\r\n    font-size:22px;\r\n    background-color: #165688!important;\r\n    cursor: pointer;\r\n}\r\n.btn-permit-disabled {\r\n    margin-left: 15px !important;\r\n    border-radius: 50% !important;\r\n    font-size:22px;\r\n    background-color: #165688!important;\r\n    cursor: not-allowed !important;\r\n}\r\n/* .button-shadow {\r\n    box-shadow: 0 3.5px 7.8px 0 rgba(0,0,0,.532), 0 0.6px 2px 0 rgba(0,0,0,.508) !important;\r\n} */\r\n.div-buttons {\r\n    z-index: 5;\r\n    position: fixed;\r\n    bottom: -7%;\r\n    margin-bottom: 68px;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    /* width: 94.5%; */\r\n    right: 45px;\r\n}\r\n.comment {\r\n    z-index: 5;\r\n    position: fixed;\r\n    bottom: -7%;\r\n    margin-bottom: 68px;\r\n    justify-content: flex-start;\r\n    display: flex;\r\n    margin-left: 36px !important;\r\n}\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-inputtext {\r\n    /* width: 250px !important; */\r\n    margin: 0;\r\n    outline: medium none;\r\n    padding: .25em;\r\n    font-weight: normal;\r\n}\r\n\r\n:host ::ng-deep input[type=text] {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n:host ::ng-deep input[disabled] {\r\n    color: #848484!important;\r\n    background-color: white!important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;\r\n}\r\n\r\n.approveMessage {\r\n    font-style: italic;\r\n    font-weight: normal;\r\n    font-size: 11px;\r\n}\r\n\r\n/* .permitTypeImages {\r\n    height: 62px;\r\n    width: 100%;\r\n} */\r\n\r\n.permitTypeImages {\r\n    /* max-height: 88px;\r\n    height: 100%;\r\n     width: 100%;\r\n     min-width: 88px; */\r\n    /* width: 100%;\r\n     height: 100%; */\r\n    width: 70px;\r\n    height: 71px;\r\n}\r\n\r\n#messagebox {\r\n    border: solid 1px #cecece;\r\n    color: #4B515D;\r\n}\r\n\r\n#messagebox.success {\r\n    /* border: solid 1px #00C851;\r\n    border-left: solid 4px #00C851; */\r\n    padding: 10px;\r\n}\r\n\r\n.success-color {\r\n    color: transparent;\r\n}\r\n\r\n.status {\r\n    padding: 2px;\r\n    font-size: 13px;\r\n}\r\n\r\n.message-header {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.message-border {\r\n    margin: 5px;\r\n    height: auto;\r\n    width: auto;\r\n    border: 1px solid rgba(22, 87, 136, 0.8);\r\n    border-left: 5px solid rgba(22, 87, 136, 0.8);\r\n    padding: 5px;\r\n    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.status-overlay {\r\n    position: fixed;\r\n    right: 30px;\r\n    /* top: 97px; */\r\n    /* top: 8%; */\r\n    top: 55px;\r\n    width: 76px;\r\n    height: 23px;\r\n    /* bottom: 7px; */\r\n    margin-left: 12px;\r\n    padding-top: 2px;\r\n    cursor: pointer;\r\n    background-color: #165788;\r\n    color: #FFF !important;\r\n    background-position: -496px -229px;\r\n    padding-left: 7px;\r\n    letter-spacing: 0.5px;\r\n    border: 1px solid #165788;\r\n    border-radius: 5px;\r\n    box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.geo-tag {\r\n    position: fixed;\r\n    right: 52px;\r\n    /* top: 90px; */\r\n    top: 8%;\r\n    width: 76px;\r\n    height: 23px;\r\n    /* bottom: 7px; */\r\n    margin-left: 12px;\r\n    padding-top: 2px;\r\n    cursor: pointer;\r\n}\r\n\r\n#commentBoxContainer {\r\n    background-color: white;\r\n    width: 98.5%;\r\n    height: 400px;\r\n    position: sticky;\r\n    top: 87px;\r\n    z-index: 1000;\r\n    right: 643px;\r\n    margin-left: 5px;\r\n    border: 1px solid #165788;\r\n    border-radius: 5px 5px 0px 0px !important;\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25)\r\n}\r\n\r\n.msg_send_btn:focus {\r\n    border: 0px solid black !important;\r\n}\r\n\r\n.userImage {\r\n    height: 80px !important;\r\n    width: 72px !important;\r\n    padding: 2px !important;\r\n    border: 2px solid #165788 !important;\r\n}\r\n\r\n.status-user-tab {\r\n    border-bottom: 3px solid #165788;\r\n}\r\n\r\n.msg_send_btn {\r\n    border: 0px solid black !important;\r\n}\r\n\r\n.disabled {\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\nhr {\r\n    clear: both;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.vrtAlignLbl {\r\n    padding: 0px 0px 0px 0px;\r\n    font: 13px !important;\r\n}\r\n\r\n.hiddenDiv {\r\n    /* height: 0; */\r\n    overflow: hidden;\r\n    height: 0;\r\n    /* display: none; */\r\n}\r\n\r\n#pnlPreview {\r\n    background-color: white;\r\n    position: relative;\r\n    /* top: -40px; */\r\n    padding-left: 30px;\r\n    padding-top: 0px;\r\n    /* padding-right: 30px; */\r\n}\r\n\r\n.left {\r\n    display: table-cell;\r\n    /* width:6%; */\r\n}\r\n\r\n.middle {\r\n    display: table-cell;\r\n    width: 100%;\r\n}\r\n\r\n.right {\r\n    display: table-cell;\r\n    width: 10%;\r\n}\r\n\r\nspan {\r\n    color: #000000 !important;\r\n}\r\n\r\n.clsTablesContainer td {\r\n    border-color: Gray !important;\r\n}\r\n\r\n.disabled {\r\n    cursor: not-allowed !important;\r\n    pointer-events: none;\r\n}\r\n\r\n:host ::ng-deep .ui-datepicker table td {\r\n    padding: 0 !important;\r\n}\r\n.clsMandatory{\r\n    border-color: red !important;\r\n}\r\n/* .pageNum {\r\n    font-family: \"DejaVu Sans\", \"Arial\", sans-serif;\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 10px;\r\n  } */\r\n  .btn-permit:hover {\r\n    border-color: none;\r\n    transform: scale(1.3);\r\n   }\r\n\r\n   .export-button-active {\r\n       cursor: pointer;\r\n   }\r\n\r\n   .export-button-disabled {\r\n    cursor: not-allowed;\r\n    filter: grayscale(1);\r\n    opacity: 0.6;\r\n}\r\n.export-button:hover {\r\n    transform: scale(1.15);\r\n}\r\n.export-button-2:hover {\r\n    /* box-shadow: 0 3.5px 7.8px 0 rgba(0,0,0,.532), 0 0.6px 2px 0 rgba(0,0,0,.508) !important; */\r\n    transform: scale(1.05);\r\n}\r\n\r\n\r\n  kendo-pdf-export {\r\n    font-family: \"DejaVu Sans\", \"Arial\", \"sans-serif\";\r\n    /* font-size: 16px; */\r\n   } \r\n\r\n   @font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans.ttf\") format(\"truetype\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Bold.ttf\") format(\"truetype\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n  }\r\n\r\n  @font-face {\r\n    font-family: \"DejaVu Sans\";\r\n    font-weight: bold;\r\n    font-style: italic;\r\n    src: url(\"https://kendo.cdn.telerik.com/2020.1.406/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf\") format(\"truetype\");\r\n  }\r\n \r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
